module.exports = __webpack_public_path__ + "img/free.4d74f14d.svg";